/* eslint-disable @typescript-eslint/default-param-last */
import dayjs from 'dayjs';
import { Reducer } from 'redux';
import { appConfig } from 'config/app';
import { ICardSession, IForgotPasswordVerifyToken, IIdentity } from 'types';
import { formatDateForApi } from 'utils';
import { IAppState, ICurrentDateRange } from '../types';
import { App } from './types';

// The date range a profile's view starts with until one is picked.
export const getDefaultDateRange = (): ICurrentDateRange => ({
  startDate: formatDateForApi(dayjs().subtract(appConfig.DATE_RANGE.DEFAULT_DAYS, 'days')),
  endDate: formatDateForApi(dayjs()),
});

const initialState: IAppState = {};

export const appReducer: Reducer<IAppState> = (state = initialState, action) => {
  switch (action.type) {
    case App.SWITCH_PROFILE: {
      if (!action.payload) return initialState; // Switching to yourself
      return {
        ...state,
        currentEmployee: action.payload,
        currentDateRange: state.currentDateRange ?? getDefaultDateRange(), // computed now, so a new login starts from today
      };
    }
    case App.SET_CURRENT_SITE: {
      if (!state.currentEmployee) return state; // a site belongs to a profile; never save one without it
      return {
        ...state,
        currentEmployee: { ...state.currentEmployee, siteId: action.payload.siteId },
      };
    }
    case App.SET_CURRENT_DATE_RANGE: {
      return {
        ...state,
        currentDateRange: { startDate: formatDateForApi(action.payload.startDate), endDate: formatDateForApi(action.payload.endDate) },
      };
    }
    case App.FORGOT_PASSWORD_VERIFY_REQUEST: {
      return {
        ...state,
        forgotPasswordVerifyToken: undefined,
      };
    }
    case App.FORGOT_PASSWORD_VERIFY_SUCCESS: {
      return {
        ...state,
        forgotPasswordVerifyToken: action.payload as IForgotPasswordVerifyToken,
      };
    }
    case App.SET_TIP_CALCULATOR_FORM_DIRTY: {
      return {
        ...state,
        isTipCalcFormDirty: action.payload.isDirty,
      };
    }
    case App.GET_CARD_SESSION_SUCCESS: {
      return {
        ...state,
        cardSession: action.payload as ICardSession,
      };
    }
    case App.DESTROY_CARD_SESSION:
      return {
        ...state,
        cardSession: null,
      };
    case App.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordIdentity: action.payload as IIdentity,
      };
    default: {
      return state;
    }
  }
};
